<div class="progress-wrapper" [style.width]="size() + 'rem'" [style.height]="size() + 'rem'">
	@if (floor(progress()) !== 100) {
	<svg class="progress-svg" [attr.viewBox]="viewBox()">
		<!-- Layer 1: Background Track -->
		<circle
			cx="50"
			cy="50"
			[attr.r]="circleRadius()"
			[style.stroke-width]="strokeWidth()"
			[style.stroke]="trackColor()"
		></circle>

		<!-- Layer 2: Progress Indicator -->
		<circle
			class="progress-indicator"
			[class.segmented]="variant() === 'segmented'"
			cx="50"
			cy="50"
			[attr.r]="circleRadius()"
			[style.stroke-width]="strokeWidth()"
			[style.stroke-dasharray]="circleCircumference()"
			[style.stroke-dashoffset]="progressOffset()"
			[style.stroke]="progressColor()"
		></circle>

		<!-- Layer 3: Borders (for segmented variant only) -->
		@if (variant() === 'segmented') {
		<!-- Inner and Outer borders for segments -->
		<circle
			class="segment-arc-border"
			cx="50"
			cy="50"
			[attr.r]="circleRadius() + strokeWidth() / 2"
			[style.stroke-width]="segmentWidth()"
			[style.stroke]="borderColor()"
		></circle>
		<circle
			class="segment-arc-border"
			cx="50"
			cy="50"
			[attr.r]="circleRadius() - strokeWidth() / 2"
			[style.stroke-width]="segmentWidth()"
			[style.stroke]="borderColor()"
		></circle>
		<!-- Lines dividing the segments -->
		<g>
			@for (border of borders(); track border.rotation) {
			<line
				class="segment-border"
				x1="50"
				[attr.y1]="borderY1()"
				x2="50"
				[attr.y2]="borderY2()"
				[style.transform]="'rotate(' + border.rotation + 'deg)'"
				[style.stroke]="borderColor()"
				[style.stroke-width]="segmentWidth()"
			></line>
			}
		</g>
		}
	</svg>
	@if (icon()) {
	<div class="progress-icon">
		<ng-icon [svg]="icon()" [color]="iconColor()" size="100%"></ng-icon>
	</div>
	} } @else {
	<ng-icon
		class="icon-progress-complete"
		[svg]="icons['check']"
		[color]="checkColor()"
		[style.background]="progressColor()"
	></ng-icon>
	}
</div>
